import { Service } from "@/interfaces/roles";
import { RootState } from "@/vuex/types";
import get from "lodash/get";
import { GetterTree } from "vuex";
import { AuthState } from "./types";

type authGetter = GetterTree<AuthState, RootState>;

export const getters: authGetter = {
  isLogged(state: AuthState): boolean {
    return state.isLogged;
  },
  services(state: AuthState): Service[] {
    return state.acountServices;
  },
  accessToken(state: AuthState): string | null {
    return state.accessToken;
  },
  loading(state: AuthState): boolean {
    return state.loading;
  },
  user(state: AuthState): object | null {
    return state.user;
  },
  userApps(state: AuthState) {
    return state.user ? state.user.applications : [];
  },
  userPermissions(state: AuthState) {
    return state.userPermissions;
  },
  hasPermission(state: AuthState) {
    return (policyPath: string, tag: string = "core") =>
      !!get(state.userPermissions, `${tag}.${policyPath}`);
  },
  appId(state: AuthState) {
    return state.appId;
  },
  // File upload Limit for the application
  fileUploadLimit(): number {
    return 8;
  },
  // File Document extention upload
  fileDocumentExtention(): string {
    return "doc/docx, dotx, odt, XML, xls/xlsx, pdf, png, jpeg/jpg, csv, txt ,tiff";
  },
  // File Image  extention upload
  fileImageExtention(): string {
    return "png, jpeg, jpg";
  }
};
